module.exports = __webpack_public_path__ + "static/media/quickenloans.068aa5f0.png";